export const COUNTDOWN_TICK = 'COUNTDOWN_TICK';

export const countdownTickCreator = () => ({
  type: COUNTDOWN_TICK,
});
